import { ISiteReccee } from '@api/models';
import { useAllUserList } from 'modules/users/hooks/useAllUserList';
// import { Button, Drawer, Label } from '@hyperflake/react-ui-library';
import { Formik, Form, ErrorMessage } from 'formik';
import { FormikSelect } from 'modules/shared/features/formik';
import { SiteRecceStatusEnum } from '@api/enum';
import FormikDatePicker from '@components/FormFields/FormikDatePicker';
import { useMemo } from 'react';
import { FormHelperText, Label } from '@library/forms';
import { Button } from '@library/buttons';
import * as Yup from 'yup';
import { Drawer } from '@hyperflake/react-ui-library';

interface AssignedSiteRecceDrawerProps {
    open: boolean;
    onClose: () => void;
    siteRecce: ISiteReccee | null;
    handleAssign: (updatedRecce: ISiteReccee) => void;
}

const AssignedSiteRecceDrawer = ({ open, onClose, siteRecce, handleAssign }: AssignedSiteRecceDrawerProps) => {
    const { allUsers } = useAllUserList();

    const userOption = useMemo(() => {
        if (!allUsers) return [];
        return [{ label: 'Select User', value: '' }, ...allUsers.map((val) => ({ label: val.name, value: val._id }))];
    }, [allUsers]);

    const schema = Yup.object().shape({
        assignedTo: Yup.string().required('User is required'),
        assignedDate: Yup.string().required('Date is required'),
    });

    if (!siteRecce) return null;

    return (
        <Drawer open={open} onClose={onClose} title="Assign Recce">
            <Formik
                initialValues={{
                    assignedTo:
                        typeof siteRecce.assignedTo === 'string'
                            ? siteRecce.assignedTo
                            : siteRecce.assignedTo?._id ?? '',
                    assignedDate: siteRecce.assignedDate || '',
                }}
                validationSchema={schema}
                onSubmit={(values) => {
                    const updatedRecce: ISiteReccee = {
                        ...siteRecce,
                        assignedTo: values.assignedTo,
                        assignedDate: values.assignedDate,
                        status: SiteRecceStatusEnum.ASSIGNED, // Update status here
                    };

                    handleAssign(updatedRecce);
                    onClose();
                }}
            >
                {() => (
                    <Form>
                        <div className="">
                            <div>
                                <Label>Assign To</Label>

                                <FormikSelect name="assignedTo" options={userOption} />
                                <FormHelperText variant="error">
                                    <ErrorMessage name="assignedTo" />
                                </FormHelperText>
                            </div>
                            <div>
                                <Label>Assigned Date</Label>
                                <FormikDatePicker name="assignedDate" isClearable />
                                <FormHelperText variant="error">
                                    <ErrorMessage name="assignedDate" />
                                </FormHelperText>
                            </div>
                        </div>

                        <div className="flex gap-4  mt-4">
                            <Button type="submit">Assign</Button>
                            <Button variant="outlined" type="button" onClick={onClose}>
                                Cancel
                            </Button>
                        </div>
                    </Form>
                )}
            </Formik>
        </Drawer>
    );
};

export default AssignedSiteRecceDrawer;
